import React, { type ReactElement, type ReactNode } from 'react';

export type ConditionWrapperProps = {
  condition: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  match: (children: ReactNode) => ReactElement<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  other?: (children: ReactNode) => ReactElement<any>;
  children: ReactNode;
};

export default function ConditionWrapper(props: ConditionWrapperProps) {
  const { condition, match, other, children, ...rest } = props;

  return condition ? match(children) : other ? other(children) : <div {...rest}>{children}</div>;
}
